import React from "react";
import { PLAN_CONFIG } from "./planUtils";

interface PlanIconProps {
  planName: string;
}

export const PlanIcon: React.FC<PlanIconProps> = ({ planName }) => {
  const config = PLAN_CONFIG[planName.toLowerCase()] || PLAN_CONFIG.free;
  const Icon = config.icon;
  return <Icon className={`h-4 w-4 ${config.color}`} />;
};
